
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/articles/added-value-of-a-good-data-monitoring-interface",
      function () {
        return require("private-next-pages/[locale]/articles/added-value-of-a-good-data-monitoring-interface.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/articles/added-value-of-a-good-data-monitoring-interface"])
      });
    }
  